<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <!-- <el-select
        placeholder="请选择是否开启"
        clearable
        size="small"
        v-model="params.enable"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in enables"
          :key="item.value"
        ></el-option>
      </el-select> -->
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center" width="250">
        <template slot-scope="scope">
          {{ scope.row.title || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="banner"
        label="BANNER图片"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.banner">暂无BANNER图片</span>
          <div
            v-else
            class="picturePreview">
            <img-load
              style="width: 80px; height: 80px"
              :src="imgUrl + scope.row.banner"
              fit="fill"
            ></img-load>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="position" label="位置" align="center" width="140">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.position == 1"
            >视频播放器下方</el-tag
          >
          <el-tag type="success" v-if="scope.row.position == 2"
            >首页</el-tag
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="跳转地址" align="center" width="300">
        <template slot-scope="scope">
          {{ scope.row.url || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="enable"
        label="是否开启"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.enable">是</el-tag>
          <el-tag v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="280"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item
          label="标题:"
          size="small"
          prop="title"
          style="width: 480px"
        >
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="图片:"
          prop="banner"
          style="width: 480px"
        >
          <base-upload
            :cover="form.banner"
            :action="uploadUrl"
            @successCallback="uploadBanner"
            :width="'120px'"
            :height="'120px'"
            :hide="true"
          ></base-upload>
        </el-form-item>
        <el-form-item label="跳转方式:" prop="hrefType" style="width:480px">
          <el-select
            v-model.number="link_type"
            size="small"
            placeholder="跳转方式"
          >
            <el-option
              v-for="item in linkTypeList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="链接地址"
          prop="link"
          v-if="link_type == 1"
          style="width:480px"
        >
          <el-input size="small" v-model="form.url"></el-input>
        </el-form-item>
        <el-form-item
          label="链接地址:"
          prop="link"
          v-if="link_type == 2"
          style="width:480px"
        >
          <el-select
            v-model="form.url"
            size="small"
            placeholder="链接地址"
            filterable
          >
            <el-option
              v-for="item in linkList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="内链ID"
          prop="inLinkId"
          style="width:480px"
          v-if="form.url == 'yinseinner://activity?id='"
        >
          <el-input size="small" v-model="inLinkId"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="位置:"
          prop="position"
          style="width: 480px"
        >
          <el-select v-model="form.position" placeholder="请选择位置">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in positions"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          size="small"
          label="起止时间:"
          prop="time"
          style="width: 480px"
        >
          <el-date-picker
            v-model="time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            @change="changeTimes"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="权重:"
          size="small"
          prop="weight"
          style="width: 480px"
        >
          <el-input v-model.number="form.weight"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="是否开启:"
          prop="enable"
          style="width: 480px"
        >
          <el-select v-model="form.enable" placeholder="请选择是否开启">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in enables"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblePreview">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import { uniteDate } from "@/utils/validator.js";
import { changeTime } from "@/utils/global";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 封面上传地址
      uploadUrl: baseConfig.baseServerUrl + "/vid/uploadStatic",
      header: {
        Authorization: local.get("userInfo").token,
      },
      dialogImageUrl: undefined, // 放大图地址
      dialogVisiblePreview: false, // 放大图
      imgUrl: baseConfig.imgUrl,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      rules: {
        content: [
          { required: true, message: "请输入跑马灯内容", trigger: "blur" },
        ],
      },
      enables: [
        {
          label: "开启",
          value: true,
        },
        {
          label: "关闭",
          value: false,
        },
      ],
      positions: [
        {
          label: "视频播放器下方",
          value: 1,
        },
        {
          label: "首页",
          value: 2,
        },
      ],
      dialogTitle: "",
      dialogVisible: false,
      time: "",
      form: {
        id: undefined,
        title: undefined, // 标题
        banner: undefined, // BANNER图片
        url: undefined, // 跑马灯链接
        position: 1, // 位置 1:视频播放器下方
        enable: true, // 是否启用
        endAt: undefined, // 结束时间
        startAt: undefined, // 开始时间
        weight: 0, // 权重
      },
      link_type: 1,
      inLinkId: "",
      linkTypeList: [
        { label: "外部浏览器跳转", value: 1 },
        { label: "内部浏览器跳转", value: 2 },
      ],
      linkList: [
        { label: "会员中心", value: "yinseinner://vip_page" },
        { label: "金币钱包", value: "yinseinner://wallet_page" },
        { label: "预售", value: "yinseinner://advancePage" },
        // { label: "活动详情", value: "yinseinner://activity?id=" },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 图片上传成功
    uploadBanner(res) {
      this.form.banner = res.data.coverImg;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisiblePreview = true;
    },
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getBannerjumpList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list || [];
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增播单
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.title = param.title;
        this.form.banner = param.banner;
        this.form.url = param.url;
        this.form.position = param.position;
        this.form.enable = param.enable;
        this.time = [uniteDate(param.startAt), uniteDate(param.endAt)];
        this.form.weight = param.weight;
        if (
          this.form.url.indexOf("vip_page") !== -1 ||
          this.form.url.indexOf("wallet_page") !== -1 ||
          this.form.url.indexOf("advancePage") !== -1
        ) {
          this.link_type = 2;
        }
        if (this.form.url.indexOf("activity") !== -1) {
          this.link_type = 2;
          const splitArr = this.form.url.split("=");
          this.form.url = splitArr[0] + "=";
          this.inLinkId = splitArr[1];
        } else {
          this.form.url = this.form.url;
        }
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let form = Object.assign({}, this.form);
          if (form.url == "yinseinner://activity?id=" && !this.inLinkId) {
            this.$message({
              type: "error",
              message: "请输入内链ID",
            });
            return;
          }
          if (form.url == "yinseinner://activity?id=") {
            form.url = form.url + this.inLinkId;
          }
          API.addBannerjump(form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let form = Object.assign({}, this.form);
          if (form.url == "yinseinner://activity?id=" && !this.inLinkId) {
            this.$message({
              type: "error",
              message: "请输入内链ID",
            });
            return;
          }
          if (form.url == "yinseinner://activity?id=") {
            form.url = form.url + this.inLinkId;
          }
          API.updateBannerjump(form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.id}</span>banner活动, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.deleteBannerjump(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.title = undefined;
      this.form.banner = undefined;
      this.form.url = undefined;
      this.form.position = 1;
      this.form.enable = true;
      this.form.endAt = undefined;
      this.form.startAt = undefined;
      this.form.weight = 0;
      this.time = "";
      this.link_type = 1;
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
    // 时间触发回调
    changeTimes(time) {
      if (time) {
        this.form.startAt = changeTime(time[0]) || "";
        this.form.endAt = changeTime(time[1]) || "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}
/deep/ .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 130px;
}
</style>
